import ViewAssessments from "../View/ViewAssessments"
import CreateAssessment from "../View/CreateAssessment"
import UnitTree from "../View/UnitTree"
import TaskRatings from "../View/TaskRatings"
import Personnel from "../View/Personnel"
import EMETLFieldManual from "../View/Components/EMETLFieldManual"

import {
    // BarChart, 
    Book,
    CalendarWeek as Calendar,
    ClipboardCheck, 
    ClipboardPlus,
    Diagram3, 
    PersonBadge, 
    // CodeSlash, 
    Star,
} from "react-bootstrap-icons"

import { 
    ButtonGroup,
} from "react-bootstrap"

import {
    useNavigate,
} from "react-router-dom"

import EMETLNavButton from "../View/Components/EMETLNavButton"

export type EMETLPage = {
    name: string,
    icon: React.ReactNode,
    page: React.ReactNode,
    title: string,
    leftNavItem?: () => React.ReactNode,
    rightNavItem?: () => React.ReactNode,
}

const PAGES: EMETLPage[] = [
    {
        name: "ViewAssessments",
        icon: (<ClipboardCheck />),
        page: (<ViewAssessments />),
        title: "View Assessments",
        leftNavItem: () => {
            const navigate = useNavigate()
            return (
                <EMETLNavButton
                    onClick={() => {
                        navigate("/Quarterly")
                    }}
                >
                    Quarterly Data
                </EMETLNavButton>
            )
        },
        rightNavItem: () => (
            <>
                <ButtonGroup>
                    <EMETLNavButton
                        onClick={() => {
                            print()
                        }}
                    >
                        Print
                    </EMETLNavButton>
                    <EMETLNavButton
                        onClick={() => {
                            alert("Exporting button should be replaced...")
                        }}
                    >
                        Export
                    </EMETLNavButton>
                </ButtonGroup>
                <EMETLNavButton
                    style={{
                        marginLeft: "8px",
                    }}
                    onClick={() => {
                        alert("Assessment filtering coming soon.")
                    }}
                >
                    <>
                        <Calendar />
                        <span
                            style={{
                                marginLeft: "8px",
                                verticalAlign: "middle",
                            }}
                        >
                            This Week
                        </span>
                    </>
                </EMETLNavButton>
            </>
        ),
    },
    {
        name: "FieldManual",
        icon: (<Book />),
        page: (<EMETLFieldManual />),
        title: "Field Manual",
    },
    {
        name: "CreateAssessment",
        icon: (<ClipboardPlus />),
        page: (<CreateAssessment />),
        title: "Create Assessment",
    },
    {
        name: "TaskRatings",
        icon: (<Star />),
        page: (<TaskRatings />),
        title: "Task Ratings",
    },
    {
        name: "Personnel",
        icon: (<PersonBadge />),
        page: (<Personnel />),
        title: "Personnel",
    },
    {
        name: "UnitTree",
        icon: (<Diagram3 />),
        page: (<UnitTree />),
        title: "Unit Tree",
    },
]

export default PAGES